// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

:host ::ng-deep {
  /* Gutters between filter controls; small inset so borders render fully. */
  /* Date-range filters (From/To): extra space before the next column. */
}
:host ::ng-deep .p-datatable {
  width: 100%;
}
:host ::ng-deep .p-datatable-thead > tr:nth-child(2) > th {
  box-sizing: border-box;
  padding-inline: 0.5rem;
}
:host ::ng-deep .p-datatable-thead > tr:nth-child(2) > th p-columnfilter,
:host ::ng-deep .p-datatable-thead > tr:nth-child(2) > th p-columnfilterformelement,
:host ::ng-deep .p-datatable-thead > tr:nth-child(2) > th idb-data-table-filter {
  display: block;
  width: 100%;
}
:host ::ng-deep .p-datatable-thead > tr:nth-child(2) > th.idb-table-filter-date-range {
  padding-inline-end: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/app/data/components/data-table/data-table.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,WAAA;AACJ;;AAEA;EAKI,0EAAA;EAaA,sEAAA;AAfJ;AAFI;EACI,WAAA;AAIR;AAAI;EACI,sBAAA;EACA,sBAAA;AAER;AAAQ;;;EAGI,cAAA;EACA,WAAA;AAEZ;AAGI;EACI,2BAAA;AADR","sourcesContent":[":host {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n:host ::ng-deep {\r\n    .p-datatable {\r\n        width: 100%;\r\n    }\r\n\r\n    /* Gutters between filter controls; small inset so borders render fully. */\r\n    .p-datatable-thead > tr:nth-child(2) > th {\r\n        box-sizing: border-box;\r\n        padding-inline: 0.5rem;\r\n\r\n        p-columnfilter,\r\n        p-columnfilterformelement,\r\n        idb-data-table-filter {\r\n            display: block;\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    /* Date-range filters (From/To): extra space before the next column. */\r\n    .p-datatable-thead > tr:nth-child(2) > th.idb-table-filter-date-range {\r\n        padding-inline-end: 0.75rem;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
